import {makeAutoObservable} from "mobx";

export default class UIStore {
    constructor() {
        this._isVoltage = true
        this._isCurrent = true
        this._isTemperature = true
        this._isHumidity = true
        this._isPower  = true
        this._isDeviceList = false
        this._isFetchVoltage = false
        this._isLon = false
        this._isLat = false

        this._isSerialNumber = true
        this._isModel = true
        this._isSerialNumberMachine = true
        this._isCity = true
        this._isAddress = true
        this._isObject = true
        this._isStatus = true
        this._isMap = true
        this._isEvent = true
        makeAutoObservable(this);
    }

    setIsFetchVoltage(bool) {
        this._isFetchVoltage = bool
    }
    setIsVoltage(bool) {
        this._isVoltage = bool
    }
    setIsCurrent(bool) {
        this._isCurrent = bool
    }
    setIsTemperature(bool) {
        this._isTemperature = bool
    }
    setIsHumidity(bool) {
        this._isHumidity = bool
    }
    setIsPower(bool) {
        this._isPower = bool
    }
    setIsDeviceList(bool) {
        this._isDeviceList = bool
    }
    setIsLon(bool) {
        this._isLon = bool
    }
    setIsLat(bool) {
        this._isLat = bool
    }
    setIsMap(bool) {
        this._isMap = bool
    }
    setIsEvent(bool) {
        this._isEvent = bool
    }
    setIsSerialNumber(bool) {
        this._isSerialNumber = bool
    }
    setIsModel(bool) {
        this._isModel = bool
    }
    setIsSerialNumberMachine(bool) {
        this._isSerialNumberMachine = bool
    }
    setIsCity(bool) {
        this._isCity = bool
    }
    setIsAddress(bool) {
        this._isAddress = bool
    }
    setIsObject(bool) {
        this._isObject = bool
    }
    setIsStatus(bool) {
        this._isStatus = bool
    }
    get isFetchVoltage() {
        return this._isFetchVoltage
    }

    get isVoltage() {
        return this._isVoltage
    }
    get isCurrent() {
        return this._isCurrent
    }
    get isTemperature() {
        return this._isTemperature
    }
    get isHumidity() {
        return this._isHumidity
    }
    get isPower() {
        return this._isPower
    }
    get isDeviceList() {
        return this._isDeviceList
    }
    get isLon() {
        return this._isLon
    }
    get isLat() {
        return this._isLat
    }
    get isSerialNumber() {
        return this._isSerialNumber
    }
    get isModel() {
        return this._isModel
    }
    get isSerialNumberMachine() {
        return this._isSerialNumberMachine
    }
    get isCity() {
        return this._isCity
    }
    get isAddress() {
        return this._isAddress
    }
    get isObject() {
        return this._isObject
    }
    get isStatus() {
        return this._isStatus
    }
    get isMap() {
        return this._isMap
    }
    get isEvent() {
        return this._isEvent
    }
}